import { ComponentType } from 'react';

import { Icon } from '@vk-hr-tek/ui/Icon';

import { BellNotification } from '@app/gen/bell';

/* eslint-disable react/no-multi-comp */
const AdvertisingOutlineIcon = () => (
  <Icon name="advertising_outline" size="24" color="original.brand.primary" />
);
const Rectangle2OutlineIcon = () => (
  <Icon name="rectangle_2_outline" size="24" color="original.brand.primary" />
);
const NarrativeOutlineIcon = () => (
  <Icon name="narrative_outline" size="24" color="original.brand.primary" />
);

export const NOTIFICATIONS_STATUSES = {
  ALL: '0',
  UNREAD: 'unread',
  READ: 'read',
} as const;

export const NOTIFIABLE_NICK_ICONS: Record<
  BellNotification['notifiable_nick'],
  ComponentType
> = {
  news: AdvertisingOutlineIcon,
  comment: AdvertisingOutlineIcon,
  survey: Rectangle2OutlineIcon,
  mention: NarrativeOutlineIcon,
  community: NarrativeOutlineIcon,
  community_manage: NarrativeOutlineIcon,
  community_post: NarrativeOutlineIcon,
  community_post_comment: NarrativeOutlineIcon,
};
